export const NO_INFORMATION = 'n/a';
export const NOT_RATED = "not rated";
export const NOT_ASSIGNED = "not assigned";